import { newDirectoryGroupAndRoleAccesses } from "@p0security/shared/integrations/directories/accesses";
import { groupAndRoleFilters } from "@p0security/shared/integrations/directories/filters";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import { Registration } from "@p0security/shared/integrations/types";

import { EntraIdComponents } from "../azure-ad/components.ts";

export const EntraIdIconUrl =
  "https://learn.microsoft.com/en-us/entra/media/index/microsoft-entra-id-color.png";

export const EntraIdRegistration = Registration({
  accesses: newDirectoryGroupAndRoleAccesses("ga"),
  category: "directory",
  components: EntraIdComponents,
  docs: { install: "microsoft-entra-id" },
  filters: groupAndRoleFilters,
  itemKind: "tenant",
  label: "Entra ID",
  logoUrl: EntraIdIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [],
});

registerIntegration("entra-id", EntraIdRegistration);
